const config = {
  baseUrl: 'https://dev-mobile.bangkokdrugstore.co.th',
  apmServiceName: 'medlink-dev',
  env: 'dev'
};
export default config;